export default "/kiban/_next/static/images/estManuFactoryId-c87bca172d3eb2194c24e300dec20164.png";